import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [ready, setReady] = useState(false);

  const check = useCallback(async () => {
    const token = localStorage.getItem("bible_admin_token");
    if (!token) { setAdmin(null); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("bible_admin_token");
      setAdmin(null);
    } finally { setReady(true); }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bible_admin_token", data.token);
    setAdmin({ email: data.email, role: data.role });
  };

  const logout = () => {
    localStorage.removeItem("bible_admin_token");
    setAdmin(null);
  };

  return (
    <AuthCtx.Provider value={{ admin, ready, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
